/**
 * TODO:
 *  - Sentry, useSentryUser()
 */
import { Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from '@components/ErrorFallback';
import { NoMatch } from '@components/NoMatch';
import { Header } from '@components/Header';
import { Navigation } from './Navigation';
import { AppWrapper, Grid, Content, TestModeBadge } from './styled';
import { Dashboard } from '@/domains/Dashboard';
import { Pages } from './utils/pages';
import { Transactions } from './Transactions';
import { Settings } from '@/domains/Settings';
import { Earnings } from './domains/Earnings';
import { useAuth } from '@contexts/Auth';
//import { useSentryUser } from './hooks/useSentryUser';

const InfoIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ verticalAlign: 'middle', marginRight: 15 }}
  >
    <path
      d='M9 5H11V7H9V5ZM9 9H11V15H9V9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z'
      fill='#333333'
      fill-opacity='0.9'
    />
  </svg>
);

function App() {
  //useSentryUser();
  const { merchantId, testMode } = useAuth();
  const homePage = merchantId ? Pages.DASHBOARD : Pages.MY_TAB;

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <AppWrapper>
        <Grid>
          <Header />
          <Navigation />
          <Content>
            {testMode && (
              <TestModeBadge>
                <InfoIcon />
                You are currently in test mode.
              </TestModeBadge>
            )}

            <Routes>
              <Route
                path={Pages.TRANSACTIONS}
                element={<Navigate to={Pages.MY_TAB} replace={true} />}
              />
              <Route path={Pages.DASHBOARD} element={<Dashboard />} />
              <Route path={Pages.MY_TAB} element={<Transactions />} />
              <Route path={Pages.EARNINGS} element={<Earnings />} />
              <Route path={Pages.SETTINGS} element={<Settings />} />
              <Route path='/' element={<Navigate to={homePage} />} />
              <Route path='*' element={<NoMatch />} />
            </Routes>
          </Content>
        </Grid>
      </AppWrapper>
    </ErrorBoundary>
  );
}

export default App;
